document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-video-section-mp4]').forEach(videoSection => {
    const videoPlayButtonOverlay = videoSection.querySelector('[data-article-video-mp4-overlay]')
    const videoPlayButton = videoSection.querySelector('[data-article-video-section-play]')
    const videoPauseButton = videoSection.querySelector('[data-article-video-section-pause]')
    const videoElement = videoSection.querySelector('[data-article-video-mp4]')
    if (!videoPlayButtonOverlay || !videoPlayButton || !videoPauseButton || !videoElement) return
    const toggleVideoPlayback = () => {
      if (videoElement.paused) {
        videoElement.play()
        videoPlayButton.classList.add('hidden')
        videoPlayButtonOverlay.classList.add('hidden')
        videoPauseButton.classList.remove('hidden')
      } else {
        videoElement.pause()
        videoPlayButton.classList.remove('hidden')
        videoPlayButtonOverlay.classList.remove('hidden')
        videoPauseButton.classList.add('hidden')
      }
    }
    videoPlayButton.addEventListener('click', toggleVideoPlayback)
    videoPauseButton.addEventListener('click', toggleVideoPlayback)
  })
})